<template>
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.5 3C7.5 2.58579 7.83579 2.25 8.25 2.25H9.75C10.1642 2.25 10.5 2.58579 10.5 3H12.45C13.4441 3 14.25 3.80589 14.25 4.8C14.25 5.04853 14.0485 5.25 13.8 5.25H13.5V14.75C13.5 15.3023 13.0523 15.75 12.5 15.75H5.5C4.94772 15.75 4.5 15.3023 4.5 14.75V5.25H4.2C3.95147 5.25 3.75 5.04853 3.75 4.8C3.75 3.80589 4.55589 3 5.55 3H7.5ZM8.25 6.5C8.25 6.22386 8.02614 6 7.75 6H7.25C6.97386 6 6.75 6.22386 6.75 6.5L6.75 13.75C6.75 14.0261 6.97386 14.25 7.25 14.25H7.75C8.02614 14.25 8.25 14.0261 8.25 13.75L8.25 6.5ZM10.75 6C11.0261 6 11.25 6.22386 11.25 6.5L11.25 13.75C11.25 14.0261 11.0261 14.25 10.75 14.25H10.25C9.97386 14.25 9.75 14.0261 9.75 13.75L9.75 6.5C9.75 6.22386 9.97386 6 10.25 6H10.75Z"
      fill="currentColor"
    />
  </svg>
</template>
IconTrashCan
